import styled from '@emotion/styled'
import { Row } from 'antd'

export const Em = styled.em<{ theme?: string }>`
  font-size: 10px;
  color: ${({ theme }) => (theme === 'dark' ? 'var(--neutral-200)' : 'var(--neutral-300)')};
`

export const ComingSoonMenu = ({ title, theme = 'light' }: { title: string; theme?: string }) => {
  return (
    <>
      <span>{title}</span>
      <Em theme={theme}>Coming Soon!</Em>
    </>
  )
}
